import PaymentHistory from "../../../Components/Admin/MemberDetail/PaymentHistory/PaymentHistory";
import MyProfile from "../../../Components/Admin/MemberDetail/MyProfile/MyProfile";
import { getProfileById } from "../../../Redux/Profile/ProfileActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import styles from "./MemberDetail.module.scss";
import { useParams } from "react-router";

function MemberDetail() {
  const [activeTab, setActiveTab] = useState("myProfile");
  const dispatch = useDispatch<AppDispatch>();
  const { profileByIdLoading } = useSelector(
    (state: RootState) => state.profile,
  );
  const { id } = useParams<{ id: string }>();

  const tabs = [
    {
      label: "My Profile",
      value: "myProfile",
    },
    {
      label: "Payment History",
      value: "paymentHistory",
    },
  ];
  const tabsRenderer = () => {
    return (
      <React.Fragment>
        <div className={styles.tabsContainer}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={
                activeTab === tab.value ? styles.activeTab : styles.tab
              }
              onClick={() => setActiveTab(tab.value)}
            >
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
        <div className={styles.tabContent}>
          {activeTab === "myProfile" && <MyProfile />}
          {activeTab === "paymentHistory" && <PaymentHistory />}
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    dispatch(getProfileById({ memberId: Number(id) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (profileByIdLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Profile</p>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.tabsContainer}>{tabsRenderer()}</div>
      </div>
    </div>
  );
}

export default MemberDetail;
